import { Box, Theme2Provider } from '@dtx-company/design-system/src'
import { EmptyNavPageContainer } from '../../layout/EmptyNavPageContainer/EmptyNavPageContainer'
import { Footer } from '../../layout/footer'
import { HowToSchema } from '@dtx-company/app/shared/code/src/components/Homepage/HowToSchema'
import { LOCGPrismicProvider } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/LOCGPrismicContext'
import { LocgV2DataMock } from './LocgMockData'
import { LockedFeatureModal } from '../../../shared/common/src/components/LockedFeatureModal/LockedFeatureModal'
import { LoggedOutCodeGenerator } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/LoggedOutCodeGenerator'
import { MarketingTopNav } from '../../TopNav/v2/MarketingTopNav'
import { Meta } from '../../../constants/meta'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useScreenSizeBreakpoints } from '@dtx-company/app/shared/common/src/hooks/useScreenSizeBreakpoints'
import dynamic from 'next/dynamic'

const LongAndColorful = dynamic(() =>
  import(
    '@dtx-company/app/shared/code/src/components/Homepage/HomepageStaticContent/variants/V2-LongAndColorful'
  ).then(mod => mod.LongAndColorful)
)

export interface FreeQrCodeGeneratorPageProps {
  injectedMeta?: Meta
}

const LOCGPageDescription =
  'Create a free custom QR code now! With colors, patterns, privacy,  and analytics, Flowcode is the #1 free QR code generator. Download your code today.'

export const FreeQrCodeGeneratorPage = (props: FreeQrCodeGeneratorPageProps): JSX.Element => {
  const { injectedMeta } = props
  const { isMobile } = useScreenSizeBreakpoints()
  const { isAuthenticated } = useAuthState()

  return (
    <Theme2Provider>
      <EmptyNavPageContainer
        page={Routes.FREE_QR_CODE_GENERATOR}
        stickyHeader={true}
        injectedMeta={{
          ...injectedMeta,
          description: LOCGPageDescription,
          title: 'Free QR Code Generator | Flowcode'
        }}
        header={<MarketingTopNav isFlowpageRoute={false} isLoggedIn={isAuthenticated} />}
      >
        <LOCGPrismicProvider locgV2Data={LocgV2DataMock}>
          <Box>
            <LoggedOutCodeGenerator />
            {!isMobile && <LongAndColorful />}
          </Box>
        </LOCGPrismicProvider>
        <HowToSchema />
        {!isMobile && <Footer />}
        <LockedFeatureModal />
      </EmptyNavPageContainer>
    </Theme2Provider>
  )
}
